"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var name = _ref.name,
      room = _ref.room,
      seeAllUrl = _ref.seeAllUrl;
  return "\n<div class=\"collection-container\">\n    <div class=\"Hero-banner ".concat(!!room && "is-".concat(room.themeName), "\"></div>\n    <div class=\"row\">\n        <div class=\"columns small-12 Collection Standard\">\n            \n                <h2 class=\"collectionTitle Label left invisible\" tabindex=\"-1\">\n                    <a href=\"").concat(seeAllUrl, "\" class=\"TitleLink Carousel-titleLink ").concat(!!room && "is-".concat(room.themeName), "\">\n                        ").concat(name, "\n                        <i class=\"icon-forward-arrow secondary-color\"></i>\n                    </a>\n                </h2>\n                <a href=\"").concat(seeAllUrl, "\" role=\"link\" aria-label=\"").concat(html('carousel.seeAllTitles', {
    collectionName: name
  }), "\" class=\"Carousel-seeAll u-allCaps button radius no-outline\">\n                    ").concat(html('seeAll'), "\n                </a>\n            \n            <div class=\"Titles\">\n                <ul class=\"titleContainer\"></ul>\n            </div>\n        </div>\n    </div>\n</div>");
};

exports["default"] = _default;